import React from 'react'
import styled from 'styled-components'
import { Link as BaseLink } from 'gatsby'
import { Button, Icon } from '@foundation-lib/ui'
import {
  faHeadphonesAlt,
  faBookOpen,
  faTabletAlt,
} from '@foundation-lib/ui/icons/solid'
import { ListTitle } from 'src/features/lists'

export const Container = styled.li`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 0 1rem;
`

export const ImageLink = styled(BaseLink)`
  flex: 0 0;
  outline: 0;
`

export const Image = styled.img`
  display: block;
  width: 4.5rem;
  height: auto;
  margin-right: 1rem;
  @media only screen and (min-width: 450px) {
    width: 6rem;
  }
  @media only screen and (min-width: 600px) and (max-width: 799.98px) {
    width: 7.5rem;
    margin-right: 1.25rem;
  }
  @media only screen and (min-width: 1000px) {
    width: 9rem;
    margin-right: 1.25rem;
  }
`

export const Details = styled.div`
  flex: 1 1;
`

export const Plank = styled.div`
  width: 6rem;
  height: 0;
  margin-bottom: 0.75rem;
  border-bottom: 5px solid ${p => p.color || p.theme.body};
`

export const Link = styled(BaseLink)`
  outline: 0;
  text-decoration: none;
`

export const Title = styled.h4`
  margin-top: 0;
  margin-bottom: 0.75rem;
  font-family: 'Bitter', serif;
  font-size: 1rem;
  font-weight: 800;
  color: ${p => p.theme.primary};
  @media only screen and (min-width: 450px) {
    font-size: 1.25rem;
  }
  @media only screen and (min-width: 1000px) {
    font-size: 1.5rem;
  }
`

export const Description = styled.div`
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  @media only screen and (min-width: 600px) {
    font-size: 1rem;
  }
`

const ButtonLink = styled(BaseLink)`
  background-color: transparent;
  border-color: #6f5c37;
  color: #6f5c37;
  &:hover {
    background-color: #f9f8f6;
    border-color: #6f5c37;
  }
  @media only screen and (max-width: 599.98px) {
    padding: 0.5rem 0.75rem;
  }
  @media only screen and (min-width: 800px) and (max-width: 999.98px) {
    padding: 0.5rem 0.75rem;
  }
`

const Formats = styled.div`
  display: flex;
`

const Format = styled(({ className, icon, children, to }) => (
  <Link className={className} to={to}>
    <Icon icon={icon} />
    {children}
  </Link>
))`
  font-size: 18px;
  color: inherit;
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;

  & + & {
    margin-left: 25px;
  }

  svg {
    font-size: 30px;
    margin-bottom: 7px;
  }
`

export const ProductTile = ({
  color,
  img,
  title,
  href,
  description,
  excerpt,
  options,
}) => (
  <Container>
    <ImageLink to={href}>
      <Image src={img} alt="" />
    </ImageLink>
    <Details>
      <Plank color={color} />
      <Link to={href}>
        <Title>{title}</Title>
      </Link>
      <Description>{description || excerpt}</Description>
      {options.length > 1 ? (
        <Formats>
          {options.map(({ type }) => (
            <Format
              to={`${href}/${type}`}
              icon={
                {
                  hardcover: faBookOpen,
                  paperback: faBookOpen,
                  ebook: faTabletAlt,
                  audiobook: faHeadphonesAlt,
                }[type]
              }
            >
              {
                {
                  hardcover: 'Book',
                  paperback: 'Book',
                  ebook: 'eBook',
                  audiobook: 'Audio',
                }[type]
              }
            </Format>
          ))}
        </Formats>
      ) : (
        <Button as={ButtonLink} to={href} brand="primary" outline>
          Buy the book
        </Button>
      )}
    </Details>
  </Container>
)

export const ListContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
  padding-left: 0;
  list-style: none;
  li {
    margin-bottom: 1.5rem;
    @media only screen and (min-width: 800px) {
      width: 50%;
    }
  }
`

const ProductList = ({ items, title, ItemComponent = ProductTile }) => (
  <>
    <ListTitle>{title}</ListTitle>
    <ListContainer>
      {items.map(item => (
        <ItemComponent {...item} />
      ))}
    </ListContainer>
  </>
)

export default ProductList
